import React, { useState } from 'react';
import classes from "./styles/navbar.module.css";
import { Link, useNavigate } from 'react-router-dom';
import fLogo from "../../assets/fLogo.jpg";
import sLogo from "../../assets/sLogo.jpg";
import hemburgerIcon from "../../assets/hemburger.png";

const Navbar = () => {
    const navigate = useNavigate();
    const [isMenuOpen, setIsMenuOpen] = useState(false);

    const toggleMenu = () => {
      setIsMenuOpen((prev) => !prev);
    };

      const scrollToFaq = () => {
        const element = document.getElementById("FaqSection");
        if (element) {
          element.scrollIntoView({ behavior: 'smooth' });
        }else{
          navigate("/");
          const delayImport = () => {
            const element2 = document.getElementById("FaqSection");
            element2.scrollIntoView({ behavior: 'smooth' });
          };
          const timeoutId = setTimeout(() => {
            delayImport();
          }, 300);
          return () => clearTimeout(timeoutId);
        }
      };

      const scrollToContact = () => {
        const element = document.getElementById("DiscoveryCallSection");
        if (element) {
          element.scrollIntoView({ behavior: 'smooth' });
        }else{
          navigate("/");
          const delayImport = () => {
            const element2 = document.getElementById("DiscoveryCallSection");
            element2.scrollIntoView({ behavior: 'smooth' });
          };
          const timeoutId = setTimeout(() => {
            delayImport();
          }, 300);
          return () => clearTimeout(timeoutId);
        }
      };

      const scrollToCoach = () => {
        const element = document.getElementById("KnowYourCoachSection");
        const scrollWithOffset = (el) => {
          const offset = -80;
          const topPos = el.getBoundingClientRect().top + window.pageYOffset + offset;
          window.scrollTo({ top: topPos, behavior: 'smooth' });
        };
        if (element) {
          scrollWithOffset(element);
        } else {
          navigate("/");
      
          const delayImport = () => {
            const element2 = document.getElementById("KnowYourCoachSection");
            if (element2) {
              scrollWithOffset(element2);
            }
          };
          const timeoutId = setTimeout(() => {
            delayImport();
          }, 300);
          return () => clearTimeout(timeoutId);
        }
      };

      const scrollToProgram = () => {
        const element = document.getElementById("ProgramSection");
        const scrollWithOffset = (el) => {
          const offset = 0;
          const topPos = el.getBoundingClientRect().top + window.pageYOffset + offset;
          window.scrollTo({ top: topPos, behavior: 'smooth' });
        };
        if (element) {
          scrollWithOffset(element);
        } else {
          navigate("/");
      
          const delayImport = () => {
            const element2 = document.getElementById("ProgramSection");
            if (element2) {
              scrollWithOffset(element2);
            }
          };
          const timeoutId = setTimeout(() => {
            delayImport();
          }, 300);
          return () => clearTimeout(timeoutId);
        }
      };

      const initiateWhatsAppChat = () => {
        const phoneNumber = "+917389940354"; // Your WhatsApp number
        const message = `Hi! I'm interested in Online Fitness & Nutrition batches. Please can you share the details!`;
        const whatsappURL = `https://wa.me/${phoneNumber.replace(/\D/g, "")}?text=${encodeURIComponent(message)}`;
        window.open(whatsappURL, "_blank"); // Opens the WhatsApp link in a new tab
      };
      

  return (
    <div className={classes.container}>
      <div className={classes.innerCon}>
        <div className={classes.leftCon} onClick={() => { navigate("/"); setTimeout(() => { window.scrollTo({ top: 0, behavior: 'smooth' });}, 200);}}>
          <img src={fLogo} alt='logo' className={classes.fLogo}/>
          <img src={sLogo} alt="logo" className={classes.sLogo}/>
        </div>
        <div className={classes.rightCon}>
          <button  onClick={() => { navigate("/"); setTimeout(() => { window.scrollTo({ top: 0, behavior: 'smooth' });}, 200);}}>Home</button>
          <button onClick={scrollToCoach}>Know Your Coach</button>
          <button onClick={scrollToProgram}>Programs</button>
          <button onClick={scrollToFaq}>FAQ</button>
          <Link to="https://blog.getfitwithsusmita.com" target='_blank'>Blog</Link>
          <button onClick={scrollToContact}>Contact us</button>
          <Link to="/privacy">Privacy</Link>
        </div>
        <div className={classes.iconCon}>
          <a href="https://www.facebook.com/susmita.a.roy.1" target='_blank' rel="noopener noreferrer"><img src="https://cdn-icons-png.flaticon.com/128/2504/2504903.png" alt="" /></a>
          <a href="https://www.instagram.com/getfitwithsusmita" target='_blank' rel="noopener noreferrer"><img src="https://cdn-icons-png.flaticon.com/128/2111/2111463.png" alt="" /></a>
          <button onClick={initiateWhatsAppChat}><img src="https://cdn-icons-png.flaticon.com/128/2504/2504957.png" alt="" /></button>
        </div>



        <div className={classes.mobilemenu}>
          <img
            src={hemburgerIcon}
            alt="Hamburger Icon"
            onClick={toggleMenu}
            className={classes.hamburgerIcon}
          />

          {/* Menu */}
          {isMenuOpen && (
            <div className={classes.pagesConMobile} onClick={toggleMenu}>
              <div className={classes.rightConMobile}>
                <button  onClick={() => { navigate("/"); setTimeout(() => { window.scrollTo({ top: 0, behavior: 'smooth' });}, 200);}}>Home</button>
                <button onClick={scrollToCoach}>Know Your Coach</button>
                <button onClick={scrollToProgram}>Programs</button>
                <button onClick={scrollToFaq}>FAQ</button>
                <Link to="https://blog.getfitwithsusmita.com" target='_blank'>Blog</Link>
                <button onClick={scrollToContact}>Contact us</button>
                <Link to="/privacy">Privacy</Link>
              </div>
              <div className={classes.iconConMobile}>
                <a href="https://www.facebook.com/susmita.a.roy.1" target='_blank' rel="noopener noreferrer"><img src="https://cdn-icons-png.flaticon.com/128/2504/2504903.png" alt="" /></a>
                <a href="https://www.instagram.com/getfitwithsusmita" target='_blank' rel="noopener noreferrer"><img src="https://cdn-icons-png.flaticon.com/128/2111/2111463.png" alt="" /></a>
                <button onClick={initiateWhatsAppChat}><img src="https://cdn-icons-png.flaticon.com/128/2504/2504957.png" alt="" /></button>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  )
}

export default Navbar
